import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import UserInfo from 'components/prefabricated/UserInfo';
import {COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION} from 'constants/ActionTypes';
import {toggleCollapsedNav, updateWindowWidth} from 'actions/Setting';
import SideBarContent from "./SideBarContent";
// import BBIconCircleDotsTour from "../../assets/bbCustomIcons/BBIconCircleDotsTour";
import MasqueradeToolbar from "../../components/customBreachBits/admin/MasqueradeToolbar";

const SideBar = () => {
  const dispatch = useDispatch();
  const { drawerType, width, navigationStyle} = useSelector(({settings}) => settings);
  const {navCollapsed} = useSelector(({common}) => common);

  useEffect(() => {
    window.addEventListener('resize', () => {
      dispatch(updateWindowWidth(window.innerWidth))
    });
  }, [dispatch]);

  const onToggleCollapsedNav = (e) => {
    dispatch(toggleCollapsedNav());
  };

  let drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-xl-flex' : drawerType.includes(COLLAPSED_DRAWER) ? '' : 'd-flex';
  let type = 'permanent';
  if (drawerType.includes(COLLAPSED_DRAWER) || (drawerType.includes(FIXED_DRAWER) && width < 1200)) {
    type = 'temporary';
  }

  if (navigationStyle === HORIZONTAL_NAVIGATION) {
    drawerStyle = '';
    type = 'temporary';
  }

  // console.log("navCollapsed in drawer file",type, navCollapsed)
  return (
    <div className={`app-sidebar d-none ${drawerStyle}`}>
      <Drawer className="app-sidebar-content"
                variant={type}
                open={type.includes('temporary') ? navCollapsed : true}
                onClose={onToggleCollapsedNav}
                classes={{
                  paper: 'side-nav',
                }}
      >
        <MasqueradeToolbar/>
        <UserInfo/>
        <SideBarContent/>

        {/*<div className={"d-flex justify-content-center align-items-center guided-tour-panel shadow"} style={{paddingBottom:12,paddingTop:10, height:"90px", borderTop: "solid 1px gray"}}>*/}
          {/*<div id="tourArrowsAnchor" ><Tooltip title={"Take a Guided Tour.  Some pages offer a Guided Tour.  If one is available, a beacon will appear in the circle.  Click the beacon to start."}><span><BBIconTutorialArrows  style={{fontSize: "45px"}}/></span></Tooltip></div>*/}

      {/*<div>*/}
      {/*  <div style={{position: "relative", width: 50}}>*/}
      {/*    <Tooltip title={"A Guided Tour not available for this page.  If a Guided Tour is available for this page, a beacon will appear here."}><span><BBIconCircleDotsTour className={"text-electric-blue tourStepBeaconCircle"} style={{fontSize:50}}>i</BBIconCircleDotsTour></span></Tooltip>*/}
      {/*    <div className={"tourStep0"} style={{position: "absolute", top: 25, left: 18}} />*/}
      {/*  </div>*/}
      {/*  /!*<div>*!/*/}
      {/*  /!*  Guided Tour*!/*/}
      {/*  /!*</div>*!/*/}
      {/*</div>*/}





        {/*</div>*/}
        {/*<Tooltip title={"Powered by the BreachBits BreachBoard℠ and AiPT℠."}>*/}
        {/*  <div className={"text-center mt-3 mb-3"} >*/}
        {/*    <a href={"https://www.breachbits.com"}>*/}
        {/*      <div style={{opacity: 0.8, backgroundImage: `url(${BBLogoImg})`, margin: "auto", width: "110px", backgroundRepeat: "no-repeat", height: "35px"}}>*/}
        {/*      </div>*/}
        {/*    </a>*/}
        {/*  </div>*/}
        {/*</Tooltip>*/}
        <br/>

      </Drawer>
    </div>
  );
};


export default withRouter(SideBar);

